import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ItemV2Main from "@/components/itemV2/itemV2Main.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'configurationOverview',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ItemV2Main))
}
}

})